export default __webpack_public_path__ + "static/media/Adeola.ce403bd2.png";